export enum EntityDetailDividerStyle {
  EntityListTrailing = 'simx-entity-detail-divider-style--entity-list-trailing',
  EntityTrailing = 'simx-entity-detail-divider-style--entity-trailing',
  Heavy = 'simx-entity-detail-divider-style--heavy',
  Light = 'simx-entity-detail-divider-style--light',
}
